<div class="row font-name">
  <label>EDIT FONT:</label>
  <icn-dropdown
    [selectedValue]="fontId"
    (selectedValueChange)="onFontIdChange($event)"
    [position]="'bottom'"
  >
    <icn-dropdown-item
      *ngFor="let font of fonts"
      [title]="font.name"
      [value]="font.id"
    >
    </icn-dropdown-item>
  </icn-dropdown>
  <icn-number-input
    [step]="1"
    [min]="0"
    [max]="100"
    [maxLength]="3"
    [minLength]="1"
    [sign]="'%'"
    [theme]="'white'"
    [value]="size"
    (valueChange)="onSizeChange($event)"
    [disabled]="shrinkToFit"
  >
  </icn-number-input>
  <div class="checkbox-input" [class.active]="shrinkToFit">
    <div (click)="onShrinkToFitChange()">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
  </div>
  <span class="shrink-to-fit-label"> Shrink to fit </span>
</div>

<div class="row">
  <label>TEXT COLOR:</label>
  <icn-color-picker
    [value]="color"
    (valueChange)="onColorChange($event)"
  ></icn-color-picker>
</div>

<div class="row">
  <label>ALIGN:</label>
  <icn-segment [value]="align" (valueChange)="onAlignChange($event)">
    <icn-segment-button
      [value]="textAlign.Left"
      [icon]="'/assets/icons/align-left.svg'"
    >
    </icn-segment-button>
    <icn-segment-button
      [value]="textAlign.Center"
      [icon]="'/assets/icons/align-center.svg'"
    >
    </icn-segment-button>
    <icn-segment-button
      [value]="textAlign.Right"
      [icon]="'/assets/icons/align-right.svg'"
    >
    </icn-segment-button>
  </icn-segment>
</div>
